import React from 'react';
import { KText } from '@/component/RtlLayout';
import { lang } from '@/common/const';
import { CountryNameList, currentCountry } from '@/common/const';
import { $k18n } from '@/common/i18n';

const LOCALE = lang || 'en';

const isIdn = CountryNameList.IDN.includes(currentCountry);
const isBra = CountryNameList.BRA.includes(currentCountry);
const spliceStr = (str, newStr) => {
    return str.slice(0, -2) + newStr + str.slice(-2);
};
// 20000 => R$200,00
// 2000 => R$20,00
// 200 => R$2,00
// 20 => R$0,20
// 2 => R$0,02
// 看后来master 代码里 这方法已经不用了
export const formatPrice = (price: number) => {
    const priceStr = price.toString();
    const priceStrNew = spliceStr(priceStr, ',');
    if (price < 100) {
        if (price < 10) {
            return `R$0,0${price}`;
        }
        return `R$0,${price}`;
    }
    return `R$${priceStrNew}`;
};

export const fromPriceDisplay = (price: string) => {
    switch (LOCALE) {
        case 'zh':
            return (
                <KText rtlClassName={['normal-price', isIdn ? 'idn' : '']}>
                    {price}
                    <KText rtlClassName={['normal-price-small']}>起</KText>
                </KText>
            );
            break;
        case 'es':
            return (
                <KText rtlClassName={['normal-price', isIdn ? 'idn' : '']}>
                    <KText rtlClassName={['normal-price-small']}>Desde </KText>
                    {price}
                </KText>
            );
            break;
        case 'pt-BR':
            return (
                <KText rtlClassName={['normal-price', isIdn ? 'idn' : '']}>
                    <KText rtlClassName={['normal-price-small']}>A partir de </KText>
                    {price}
                </KText>
            );
            break;
        case 'id':
            return (
                <KText rtlClassName={['normal-price', isIdn ? 'idn' : '']}>
                    <KText rtlClassName={['normal-price-small']}>Dari </KText>
                    {price}
                </KText>
            );
            break;
        default:
            return (
                <KText rtlClassName={['normal-price', isIdn ? 'idn' : '']}>
                    <KText rtlClassName={['normal-price-small']}>From </KText>
                    {price}
                </KText>
            );
            break;
    }
};

export const fromPriceDisplayWith = priceDispaly => {
    switch (LOCALE) {
        case 'zh':
            return (
                <KText rtlClassName={['normal-price', isIdn ? 'idn' : '']}>
                    {priceDispaly}
                    <KText rtlClassName={['normal-price-small']}>起</KText>
                </KText>
            );
            break;
        case 'es':
            return (
                <KText rtlClassName={['normal-price', isIdn ? 'idn' : '']}>
                    <KText rtlClassName={['normal-price-small']}>Desde </KText>
                    {priceDispaly}
                </KText>
            );
            break;
        case 'pt-BR':
            return (
                <KText rtlClassName={['normal-price', isIdn ? 'idn' : '']}>
                    <KText rtlClassName={['normal-price-small']}>A partir de </KText>
                    {priceDispaly}
                </KText>
            );
            break;
        case 'id':
            return (
                <KText rtlClassName={['normal-price', isIdn ? 'idn' : '']}>
                    <KText rtlClassName={['normal-price-small']}>Dari </KText>
                    {priceDispaly}
                </KText>
            );
            break;
        default:
            return (
                <KText rtlClassName={['normal-price', isIdn ? 'idn' : '']}>
                    <KText rtlClassName={['normal-price-small']}>From </KText>
                    {priceDispaly}
                </KText>
            );
            break;
    }
};

export const productSales = (num: string) => {
    // let _num = num;
    // if (num > 1000000) {
    //     _num = Math.floor(num / 1000000) + 'm';
    // } else if (num > 1000) {
    //     _num = Math.floor(num / 1000) + 'k';
    // }
    switch (LOCALE) {
        case 'zh':
            return `已售${num}`;
            break;
        case 'es':
            return `${num} Vendido`;
            break;
        case 'pt-BR':
            return `${num} Vendidos`;
            break;
        case 'id':
            return `Terjual ${num}`;
            break;
        default:
            return `${num} Sold`;
            break;
    }
};

export const fromPrice = (price: string) => {
    switch (LOCALE) {
        case 'zh':
            return `${price} ${$k18n({ text: '起' })}`;
        default:
            return `${$k18n({ text: '起' })} ${price}`;
    }
};

export const fromPriceDisplayForSpecPopLine = (price: string) => {
    switch (LOCALE) {
        case 'zh':
            return (
                <KText>
                    <KText rtlClassName={'product-price-display-text'}>{price}</KText>
                    <KText rtlClassName={'product-price-display-from-text'}>起</KText>
                </KText>
            );
            break;
        case 'es':
            return (
                <KText>
                    <KText rtlClassName={'product-price-display-from-text'}>Desde </KText>
                    <KText rtlClassName={'product-price-display-text'}>{price}</KText>
                </KText>
            );
            break;
        case 'pt-BR':
            return (
                <KText>
                    <KText rtlClassName={'product-price-display-from-text'}>A partir de </KText>
                    <KText rtlClassName={'product-price-display-text'}>{price}</KText>
                </KText>
            );
            break;
        case 'id':
            return (
                <KText>
                    <KText rtlClassName={'product-price-display-from-text'}>Dari </KText>
                    <KText rtlClassName={'product-price-display-text'}>{price}</KText>
                </KText>
            );
            break;
        default:
            return (
                <KText>
                    <KText rtlClassName={'product-price-display-from-text'}>From </KText>
                    <KText rtlClassName={'product-price-display-text'}>{price}</KText>
                </KText>
            );
            break;
    }
};

// 巴西印尼是一致的 暂时不需要改动 默认巴西即可
export function formatNumber(num = 0, currency = 'BRA') {
    return num.toLocaleString('pt-BR', { currency });
}

const WebCurrencyT = {
    BRA: 'mil',
    IDN: 'rb',
};

const WebCurrencyM = {
    BRA: 'milhão',
    IDN: 'jt',
};

const WebCurrencyG = {
    BRA: 'milhões',
    IDN: 'jt',
};

// n 保留小数点后几位
function formatNumberManually(num: number, _n: number) {
    // 小数点
    let decimal = '.';
    // 分隔符
    let separator = ',';
    if (isIdn || isBra) {
        decimal = ',';
        separator = '.';
    }
    const n = _n >= 0 && _n <= 20 ? _n : 2;
    const number = parseFloat((num + '').replace(/[^\d\.-]/g, '')).toFixed(n) + '';
    const l = number.split('.')[0].split('').reverse();
    const r = number.split('.')[1];
    let t = '';
    for (let i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 === 0 && i + 1 !== l.length ? separator : '');
    }
    if (r) {
        return t.split('').reverse().join('') + decimal + r;
    }
    return t.split('').reverse().join('');
}

export function newFormatNumber(num = 0, currency = 'BRA') {
    if (!['BRA', 'IDN'].includes(currency)) {
        return formatNumber(num);
    }
    if (num < 10000) {
        return formatNumberManually(Number(num), 0);
    }
    if (num >= 10000 && num < 1000000) {
        return `${formatNumberManually(Number((num / 1000).toFixed(0)), 0)} ${WebCurrencyT[currency]}`;
    }
    if (num >= 1000000 && num < 2000000) {
        return `${formatNumberManually(Number((num / 1000000).toFixed(0)), 0)} ${WebCurrencyM[currency]}`;
    }
    if (num >= 2000000) {
        return `${formatNumberManually(Number((num / 1000000).toFixed(0)), 0)} ${WebCurrencyG[currency]}`;
    }
}
